import React from 'react';

import { Box, Text } from '@mantine/core';
import { IconInfoSquare } from '@tabler/icons-react';
import KiloTooltip from 'components/KiloTooltip';

const UtilizationRateHeader = (): JSX.Element => {
  return (
    <Box display='flex'>
      <Text>Utilization Rate</Text>{' '}
      <KiloTooltip
        multiline
        withinPortal
        position='bottom-end'
        withArrow
        label='The utilization rate represents the percentage of the calculated expectation that was attended during the selected period.'
      >
        <IconInfoSquare size={16} style={{ cursor: 'help' }} />
      </KiloTooltip>
    </Box>
  );
};

export default UtilizationRateHeader;
